var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.root.state.options.taskList.display),expression:"root.state.options.taskList.display"}],ref:"taskListWrapper",staticClass:"gantt-elastic__task-list-wrapper",style:({
    ..._vm.root.style['task-list-wrapper'],
    width: '100%',
    height: '100%',
  })},[_c('div',{ref:"taskList",staticClass:"gantt-elastic__task-list",style:({ ..._vm.root.style['task-list'] })},[_c('task-list-header'),_c('div',{ref:"taskListItems",staticClass:"gantt-elastic__task-list-items",style:({
        ..._vm.root.style['task-list-items'],
        height: _vm.root.state.options.rowsHeight + 'px',
      })},_vm._l((_vm.root.visibleTasks),function(task){return _c('task-list-item',{key:task.id,attrs:{"task":task}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }